<template>
  <SidePopup
    :title="title"
    v-on:close="onClose"
    @submit="onSubmit"
    :loading="isLoading"
    routeback="/admin/novidades"
  >
    <h4 class="text-center">Dados básicos</h4>
    <LineDivider></LineDivider>
    <FormField
      label="Título da novidade"
      v-model="form.descricao"
      :validation="$v.form.descricao"
    />
    <FormField
      label="Resumo da novidade"
      v-model="form.resumo"
      :validation="$v.form.resumo"
    />
    <h4 class="ml-3">Palavras-chave</h4>
    <v-combobox
      v-model="form.palavras_chave"
      rounded
      outlined
      chips
      label="Após digitar uma palavra-chave, aperte ENTER"
      multiple
    ></v-combobox>
    <v-row no-gutters>
      <v-col>
        <v-select
          label="Cor da novidade"
          :items="colors"
          outlined
          rounded
          dense
          v-model="form.cor"
        >
          <template v-slot:selection="{ item }">
            <v-icon :color="item.value">fa-circle</v-icon>
            <span class="ml-3">{{ item.text }}</span>
          </template>
          <template v-slot:item="{ item }">
            <v-icon :color="item.value">fa-circle</v-icon>
            <span class="ml-3">{{ item.text }}</span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="auto">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon class="ml-3 mt-2" v-on="on">far fa-question-circle</v-icon>
          </template>
          Define a cor do destaque da novidade na timeline do portal.
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <FormField
          persistenthint
          hint="Font Awesome (fas fa-lock) ou nome lógico (Sparkles, Zap…)"
          label="Icone da novidade"
          v-model="form.icone"
        />
      </v-col>
      <v-col cols="auto" class="ml-2">
        <v-select :items="icons" outlined rounded dense v-model="form.icone">
          <template v-slot:selection="{ item }">
            <v-icon v-if="item.iconClass" size="18">{{
              item.iconClass
            }}</v-icon>
            <span class="ml-3" v-text="item.text"></span>
          </template>
          <template v-slot:item="{ item }">
            <v-icon v-if="item.iconClass" size="18">{{
              item.iconClass
            }}</v-icon>
            <span class="ml-3" v-text="item.text"></span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="auto">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon class="ml-3 mt-2" v-on="on">far fa-question-circle</v-icon>
          </template>
          Ícone na bolinha e nos cards: Font Awesome ou nome lógico do portal
          (Sparkles, Zap, Tag, Shield, Package…).
        </v-tooltip>
      </v-col>
    </v-row>
    <p class="ml-3 mb-8">
      <a href="https://fontawesome.com/icons?d=gallery&p=2" target="_blank">
        Procure mais ícones aqui
      </a>
    </p>
    <h4>Conteúdo</h4>
    <NovidadesContentHelp />
    <Simplemde v-model="form.conteudo" ref="markdownEditor" />
    <template v-slot:buttons>
      <FormButton text="Salvar" submit type="submissao" />
    </template>
  </SidePopup>
</template>

<script>
import SidePopup from "@/components/SidePopup";
import LineDivider from "@/components/LineDivider";
import FormButton from "@/components/form/FormButton";
import FormField from "@/components/form/FormField";
import {
  COLOR,
  NOVIDADE_UPDATE,
  NOVIDADE_CREATE,
  NOVIDADE_LOAD
} from "@/store/actions/novidade";
import { required } from "vuelidate/lib/validators";
import Simplemde from "vue-simplemde";
import NovidadesContentHelp from "@/pages/admin/novidades/NovidadesContentHelp";
import { NOVIDADES_ADMIN_ICON_OPTIONS } from "@/utils/novidades/admin-icon-options";

export default {
  name: "NovidadeAdminForm",
  components: {
    SidePopup,
    LineDivider,
    FormButton,
    FormField,
    Simplemde,
    NovidadesContentHelp
  },
  data: () => ({
    mode: "add",
    isLoading: false,
    form: {
      descricao: "",
      resumo: "",
      cor: "green",
      icone: "",
      palavras_chave: [],
      conteudo: ""
    },
    colors: COLOR,
    icons: NOVIDADES_ADMIN_ICON_OPTIONS
  }),
  validations: {
    form: {
      descricao: { required },
      resumo: { required }
    }
  },
  methods: {
    getData(idnovidade) {
      this.isLoading = true;
      this.$store
        .dispatch(NOVIDADE_LOAD, idnovidade)
        .then(data => {
          this.form = data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.onClose();
        });
    },
    onClose(routeBack = false) {
      this.isLoading = false;
      this.$emit("close");
      if (routeBack) {
        this.$router.replace("/admin/novidades");
      }
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;
      this.isLoading = true;
      const data = this.form;
      if (this.mode == "edit") {
        this.$store
          .dispatch(NOVIDADE_UPDATE, data)
          .then(() => {
            this.$vueOnToast.pop("success", "Novidade criada com sucesso!");
            this.onClose(true);
          })
          .catch(err => {
            const erro = err.response.data.error || "Erro ao criar novidade";
            this.$vueOnToast.pop("error", erro);
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch(NOVIDADE_CREATE, data)
          .then(() => {
            this.$vueOnToast.pop("success", "Novidade atualizada com sucesso!");
            this.onClose(true);
          })
          .catch(err => {
            const erro =
              err.response.data.error || "Erro ao atualizar novidade";
            this.$vueOnToast.pop("error", erro);
            this.isLoading = false;
          });
      }
    }
  },
  computed: {
    title() {
      return this.mode == "edit" ? "Editar novidade" : "Nova novidade";
    }
  },
  created() {
    let { idnovidade } = this.$route.params;
    if (idnovidade !== "novo") {
      this.mode = "edit";
      this.getData(idnovidade);
    }
  }
};
</script>

<style>
@import "~simplemde/dist/simplemde.min.css";
</style>
